import { kmsClient } from 'api';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/react-hooks';
import { ArticleGroupAssetsQuery, ArticleGroupAssetsQueryVariables } from './__generated__/ArticleGroupAssetsQuery';

export const ARTICLE_GROUP_ASSETS = gql`
  query ArticleGroupAssetsQuery($id: ID!) {
    articleGroup(id: $id) {
      id
      title
      description
      postTexts {
        id
        text
        isBlank
        postMaloneScore {
          engagementScore
        }
      }
      headlines {
        id
        text
        isBlank
        isAutofilled
        postMaloneScore {
          engagementScore
        }
      }
      descriptions {
        id
        text
        isBlank
        isAutofilled
      }
      postMaloneProject {
        externalProjectId
        postMaloneAccount {
          id
          name
          externalAccountId
        }
      }
      policy {
        canUseNonPostMaloneTextAssets
        canCreatePostMaloneProject
      }
      ogImages {
        id
        url
      }
      articles {
        id
        title
        facebookLeadgenForms {
          id
          name
          externalId
          spec
          discardedAt
          createdAt
        }
        campaign {
          id
          name
          campaignObjective
        }
      }
    }
  }
`;

export const useArticleGroupLazyAssetsQuery = (variables: ArticleGroupAssetsQueryVariables) => {
  return useLazyQuery<ArticleGroupAssetsQuery>(ARTICLE_GROUP_ASSETS, {
    client: kmsClient,
    variables,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
